import * as React from "react";

// By: typcn
// See: https://v0.app/icon/typcn/document-add
// Example: <IconTypcnDocumentAdd width="24px" height="24px" style={{color: "#716fc3"}} />

export const AddIcon = ({
  height = "2em",
  fill = "#3E88EF",
  focusable = "false",
  ...props
}: Omit<React.SVGProps<SVGSVGElement>, "children">) => (
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 2 24 24"
    height={height}
    focusable={focusable}
    {...props}
  >
    <path
      fill={fill}
      d="M15 12h-2v-2a1 1 0 1 0-2 0v2H9a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2m4.707-4.707l-4-4A.996.996 0 0 0 15 3H7C5.346 3 4 4.346 4 6v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8a.996.996 0 0 0-.293-.707M17.586 8H16.5c-.827 0-1.5-.673-1.5-1.5V5.414zM17 19H7a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7v1.5C14 7.879 15.121 9 16.5 9H18v9a1 1 0 0 1-1 1"
    />
  </svg>
);
